module.exports = __webpack_public_path__ + "images/Virtual Color Consultation Img.6e2654ea8fdf7c3c04e03358770f77c6.jpg";